
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';
import { ScrollDirection } from '../../models';
import { SUBMODULES_PATHS } from '../../store';
import { Dictionary } from '../../utils';

@Component({
  computed: {
    ...mapState(SUBMODULES_PATHS.config, ['device'])
  }
})
export default class ClassBinder extends Vue {

  @Prop()
  dynamicClasses: Dictionary<(self: this) => boolean>;

  defaultClasses: Dictionary<(self: this) => boolean>;

  device: string;
  domElement: Element;

  get appliedClasses(): Dictionary<(self: this) => boolean> {
    return Object.assign({}, this.defaultClasses, this.dynamicClasses);
  }

  @Watch('device', { immediate: true })
  onDeviceChange(device: string, oldDevice: string) {
    this.domElement.classList.remove(`ebx-empathy-x--${ oldDevice }`);
    this.domElement.classList.add(`ebx-empathy-x--${ device }`);
  }

  @Watch('appliedClasses', { immediate: true })
  onClassesChanged() {
    this.createWatches(this.appliedClasses);
  }

  beforeCreate() {
    this.domElement = document.documentElement;
    this.defaultClasses = {
      'ebx-empathy-x--scroll-up': (self: this) => self.$store.state.core.scrollDirection === ScrollDirection.UP,
      'ebx-empathy-x--scroll-down': (self: this) => self.$store.state.core.scrollDirection === ScrollDirection.DOWN,
      'ebx-empathy-x--opened': (self: this) => self.$store.state.core.open
    };
  }

  destroyed() {
    this.domElement.classList.remove(
      `ebx-empathy-x--${ this.device }`,
      ...Object.keys(this.appliedClasses));
  }

  createWatches(dynamicClasses: Dictionary<(self: this) => boolean>) {
    Object.entries(dynamicClasses).forEach(([className, watchFunction]) =>
      this.createWatch(className, watchFunction as (this: this) => boolean));
  }

  createWatch(className: string, watchFunction: (this: this) => boolean) {
    this.$watch(
      watchFunction,
      watchValue => watchValue
        ? this.domElement.classList.add(className)
        : this.domElement.classList.remove(className),
      { immediate: true });
  }

  render() {}
}
